import defaultApi from '@/utils/request';

export default {
  // 加載列表
  S43W2001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2001_Load',
      params,
    });
  },
  S43W2001_getCityZip(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2001_getCityZip',
      params,
    });
  },
  S43W2001_DelApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2001_DelApply',
      data,
    });
  },
  S43W2001_SaveApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2001_SaveApply',
      data,
    });
  },
  S43W2001_GetPDF(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2001_GetPDF',
      responseType: 'blob',
      data,
    });
  },
  // 加載列表 // S43W2002 住宿生外宿請假申請作業
  S43W2002_LoadList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2002_LoadList',
      params,
    });
  },
  S43W2002_EditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2002_EditViewLoad',
      params,
    });
  },
  S43W2002_EditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2002_EditViewAction',
      data,
    });
  },
  S43W2002_EditViewAction5(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2002_EditViewAction5',
      data,
    });
  },
  S43W2002_Delete(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2002_Delete',
      data,
    });
  },
  S43W2002_Send(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2002_Send',
      data,
    });
  },

  // 加載列表 // S43W2003 WEN811 新生資料調查作業  -----
  S43W2003_LoadList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2003_LoadList',
      params,
    });
  },
  S43W2003_EditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2003_EditViewLoad',
      params,
    });
  },
  S43W2003_EditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2003_EditViewAction',
      data,
    });
  },
  S43W2003_SetOKAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2003_SetOKAction',
      data,
    });
  },
  S43W2003_LoadPrintPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2003_LoadPrintPDF',
      responseType: 'blob',
      params,
    });
  },
  S43W2003_LoadPrintPDF2(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2003_LoadPrintPDF2',
      responseType: 'blob',
      params,
    });
  },

  // end 加載列表 // S43W2003 WEN811 新生資料調查作業  -----

  S43W4001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S43/S43W4001_Load',
      params,
    });
  },
  S43W4003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S43/S43W4003_Load',
      params,
    });
  },
  S43W4005_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S43/S43W4005_Load',
      params,
    });
  },
  S43W4007_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S43/S43W4007_Load',
      params,
    });
  },
  S43W4007_GetPdfFile(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S43/S43W4007_GetPdfFile',
      responseType: 'blob',
      params,
    });
  },
  // ========================================================================================================
  // S43W4008 住宿生加扣點資料查詢
  S43W4008_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S43/S43W4008_Load',
      params,
    });
  },

  /// ////
  // 加載列表 // S43W2004 導生輔導資料登錄
  S43W2004_LoadList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2004_LoadList',
      params,
    });
  },
  S43W2004_EditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2004_EditViewLoad',
      params,
    });
  },
  S43W2004_EditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2004_EditViewAction',
      data,
    });
  },
  S43W2004_DeleteDtl(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2004_DeleteDtl',
      data,
    });
  },
  S43W2004_EditDtlViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2004_EditDtlViewLoad',
      params,
    });
  },
  S43W2004_EditDtlViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2004_EditDtlViewAction',
      data,
    });
  },
  S43W2004_getPagePdf(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2004_getPagePdf',
      responseType: 'blob',
      params,
    });
  },
  S43W2004_PrintViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2004_PrintViewLoad',
      params,
    });
  },
  S43W2004_ChkPermission(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2004_ChkPermission',
      params,
    });
  },
  // OFFICE HOUR
  S43W2004_LoadOHList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2004_LoadOHList',
      params,
    });
  },
  S43W2004_LoadOHcloseList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2004_LoadOHcloseList',
      params,
    });
  },
  S43W2004_OHbkAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2004_OHbkAction',
      data,
    });
  },
  S43W2004_OHEditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2004_OHEditViewLoad',
      params,
    });
  },
  S43W2004_OHEditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2004_OHEditViewAction',
      data,
    });
  },
  S43W2004_LeaveAttachmentViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2004_LeaveAttachmentViewLoad',
      params,
    });
  },
  S43W2004_LeaveAttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2004_LeaveAttachmentViewFileUpload',
      data,
    });
  },
  S43W2004_LeaveAttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2004_LeaveAttachmentViewFileDelete',
      data,
    });
  },
  S43W2004_OHEditMsgViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2004_OHEditMsgViewLoad',
      params,
    });
  },
  S43W2004_OHEditMsgViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2004_OHEditMsgViewAction',
      data,
    });
  },
  S43W2004_OHTimeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2004_OHTimeViewLoad',
      params,
    });
  },
  S43W2004_OHEditTimeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2004_OHEditTimeViewLoad',
      params,
    });
  },
  S43W2004_OHEditTimeDtlViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2004_OHEditTimeDtlViewAction',
      data,
    });
  },
  S43W2004_OHDeleteTimeDt(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2004_OHDeleteTimeDt',
      data,
    });
  },
  S43W2004_OHCopyTimeDt(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2004_OHCopyTimeDt',
      data,
    });
  },
  S43W2004_LoadOHBookList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S43/S43W2004_LoadOHBookList',
      params,
    });
  },
  S43W2004_OHEditBookDtlViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S43/S43W2004_OHEditBookDtlViewAction',
      data,
    });
  },
};
